import { RootState } from "redux/rootReducer";

export const selectIsSavingConsultationSettings = (state: RootState) =>
  state.saveConsultationSettings.loading;
export const selectSaveConsultationSettingsErrorMessage = (state: RootState) =>
  state.saveConsultationSettings.error;
export const saveConsultationSettingsDataResponse = (state: RootState) =>
  state.saveConsultationSettings.saveConsultationSettingsResponse;
